var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckbox01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  stroke: "#E2E2E2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m16.777 5.815-8.964 9.313-4.588-4.767.96-.925 3.628 3.77 8.003-8.315z",
  clipRule: "evenodd"
}))));
export default SvgIconCheckbox01;